import { Component, EventEmitter, Input, Output, OnInit, OnDestroy, ViewEncapsulation } from '@angular/core';
import { Subscription } from 'rxjs';
import { AuthenticationService } from '@app/core/authentication/authentication.service';
import { label } from '../constants/labels';
import { environment } from '@env/environment';
import { Router } from '@angular/router';
import { I18nService } from '@app/core/i18n.service';
import { rolesdef } from '@app/constants/role-def';
import { BaseAPIService } from '@app/Services/api.base.service';
import { ITenantLicenseDetails } from '@app/Models/ITenantLicenseDetails';
import { IAppVersion } from '../Models/IAppVersion';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

interface MenuItem {
  icon: string;
  label: string;
  children?: MenuItem[];
  isOpen?: boolean;
}

@Component({
  selector: 'app-sp-sidenav',
  standalone: false,
  templateUrl: './sp-sidenav.component.html',
  styleUrls: ['./sp-sidenav.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SpSidenavComponent implements OnInit, OnDestroy {
  @Input() isSidebarCollapsed = false;
  @Output() sidebarToggle = new EventEmitter<void>();
  private loginSubscription: Subscription;
  
  public loggedInUser: string | null;

  public user: any = {};
    labels: any = label;
    public roleCd: string;
    roles: any;
    public isLoggedIn: boolean = false;
    public isInternalUser: boolean = true; // default isInternalUser is true
    public urls: any = {};
    public sideNavBar: boolean;
    public all_tenantCount: number;
    public active_tenantCount: number;
    public gracePeriod_tenantCount: number;
    public expired_tenantCount: number;
    public navLinks = [
      { name: this.labels.support, link: environment.supportUrl },
      { name: this.labels.faq, link: environment.faqsUrl },
      { name: this.labels.legal, link: environment.legalUrl },
      { name: this.labels.privacyPolicy, link: environment.privacypolicyUrl },
      { name: this.labels.copyright, link: environment.copyrightUrl },
  
    ];
    public versionName: string = "";
    public language: string;
    public socialLinks = [
      { icon: 'assets/Facebook.svg', link: environment.facebookUrl },
      { icon: 'assets/Twitter.svg', link: environment.twitterUrl },
      { icon: 'assets/Youtube.svg', link: environment.youtubeUrl },
    ];
    public seLogo: string;
  

  constructor(private readonly baseService: BaseAPIService, public router: Router,
    private readonly authenticationService: AuthenticationService,
    private readonly i18nService: I18nService,) { }

  
  ngOnInit(): void {
    // Subscribe to reactive login state so the sidebar appears once login completes
    this.loginSubscription = this.authenticationService.userLoginIn$.subscribe(loggedIn => {
      this.isLoggedIn = loggedIn;
      console.log('Login state changed:', loggedIn);
      if (loggedIn) {
        this.initAuthenticatedState();
      }
    });

    // Also check synchronously for already-authenticated sessions (e.g. page refresh)
    if (this.authenticationService.isAuthenticated()) {
      this.isLoggedIn = true;
      this.initAuthenticatedState();
    }
  }

  ngOnDestroy(): void {
    if (this.loginSubscription) {
      this.loginSubscription.unsubscribe();
    }
  }

  private initAuthenticatedState(): void {
    this.loggedInUser = this.authenticationService.authenticatedUser;
    this.seLogo = 'assets/schneiderLogo.png';
    this.labels = label;
    this.sideNavBar = false;
    this.language = localStorage.getItem('language');
    this.urls = JSON.parse(this.authenticationService.urls);

    this.isInternalUser = this.authenticationService.context && JSON.parse(JSON.stringify(this.authenticationService.context.idms)).isInternal !== null ? JSON.parse(JSON.stringify(this.authenticationService.context.idms)).isInternal.toLowerCase() === 'true' : false;
    if (this.language === null) {
      this.language = this.currentLanguage;
    }
    this.roles = rolesdef;
    this.roleCd = this.authenticationService.authenticatedRoleCd;
    this.urls = JSON.parse(this.authenticationService.urls);
    this.GetAppVersion();
  }

  menuItems: MenuItem[] = [
    {
      icon: 'fas fa-home',
      label: 'Dashboard',
      isOpen: false,
      children: [
        { icon: 'fas fa-chart-pie', label: 'Analytics' },
        { icon: 'fas fa-tasks', label: 'Projects' },
      ]
    },
    {
      icon: 'fas fa-cog',
      label: 'Settings',
      isOpen: false,
      children: [
        { icon: 'fas fa-user', label: 'Profile' },
        { icon: 'fas fa-lock', label: 'Security' },
      ]
    },
    {
      icon: 'fas fa-envelope',
      label: 'Messages'
    }
  ];

  toggleSidebar() {
    this.sidebarToggle.emit();
  }

  toggleMenuItem(item: MenuItem) {
    // Only toggle if sidebar is not collapsed and item has children
    if (!this.isSidebarCollapsed && item.children) {
      item.isOpen = !item.isOpen;
    }
  }

  navigate(routerName){
    
  }

  public GetAppVersion() {
    let sessionVersionNo = sessionStorage.getItem('versionNumber');
    if (sessionVersionNo == null || sessionVersionNo == undefined || sessionVersionNo.trim() == "" || sessionVersionNo == "undefined") {
      this.baseService.GET('/Misc/GetAppVersion').subscribe((result: Array<string>) => {
        this.versionName = result[0];
        sessionStorage.setItem('versionNumber', this.versionName);
      });
    } else {
      this.versionName = sessionVersionNo;
    }
  }

  get currentLanguage(): string {
    const sslang = this.i18nService.supportedLanguages.filter(item => item.code === this.i18nService.language);
    return sslang[0].name;
  }

}


